export default "__VITE_ASSET__B$053Bzp__"